// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentNotifications_container__2R3Il","headerTitle":"PaymentNotifications_headerTitle__1_0vr"};